import { useEffect, useState } from "react";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SonicLogoCompare() {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/api/sonic-options`)
      .then((r) => r.json())
      .then((d) => {
        setOptions(d.options || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Loading sonic logo candidates…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 py-12">
      <div className="max-w-4xl mx-auto px-6">
        <header className="mb-10">
          <h1 className="text-4xl font-semibold tracking-tight text-slate-900">
            Inter-View Sonic Logo Candidates
          </h1>
          <p className="mt-3 text-slate-600 leading-relaxed">
            Seven custom-synthesised options, all royalty-free and safe for
            commercial use. Each row offers the raw chime (.wav) and the
            full 3.0&nbsp;s outro mp4 with the chime mixed in at the same
            level.
          </p>
        </header>

        <div className="space-y-4">
          {options.map((o, i) => (
            <Card key={o.slug} className="p-5" data-testid={`sonic-option-${o.slug}`}>
              <div className="flex items-start gap-6">
                <div className="text-5xl font-bold text-slate-200 w-14 leading-none">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-lg font-medium text-slate-900">
                    {o.label}
                  </div>
                  <div className="text-xs text-slate-400 mt-0.5 font-mono">
                    {o.slug}
                  </div>
                  <div className="mt-3 grid md:grid-cols-2 gap-4">
                    <div>
                      <div className="text-xs uppercase tracking-wide text-slate-500 mb-1.5">
                        Raw chime
                      </div>
                      <audio
                        controls
                        preload="none"
                        className="w-full"
                        src={`${API}${o.wav_url}`}
                        data-testid={`sonic-wav-${o.slug}`}
                      />
                    </div>
                    <div>
                      <div className="text-xs uppercase tracking-wide text-slate-500 mb-1.5">
                        In-context outro (3.0&nbsp;s)
                      </div>
                      <video
                        controls
                        preload="none"
                        className="w-full rounded-md bg-black"
                        src={`${API}${o.video_url}`}
                        data-testid={`sonic-video-${o.slug}`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <footer className="mt-10 text-sm text-slate-500">
          Once you pick a winner, share the slug (e.g. <code>04_modern_startup</code>)
          and I&rsquo;ll bake it into the bundled <code>interview_outro.mp4</code>
          and remove the others.
        </footer>
      </div>
    </div>
  );
}
